import { render, staticRenderFns } from "./DashboardImpact.vue?vue&type=template&id=25993818&scoped=true&"
import script from "./DashboardImpact.vue?vue&type=script&setup=true&lang=js&"
export * from "./DashboardImpact.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DashboardImpact.vue?vue&type=style&index=0&id=25993818&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25993818",
  null
  
)

export default component.exports